<style>
.bg {
  background: #ffffff;
  width: 100%;
  /* 删除 height:100vh; overflow:auto; */
  -webkit-font-smoothing:antialiased;
  font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.my-invest{width: 90vw;margin: 0 auto;height: 23vw;background-color: #f3f3f3;
border-radius: 3vw;position: relative;margin-top: 5vw;}
.my-invest img{display: block;position: absolute;width:8vw;left:3vw;top:3vw;}
.my-invest span{display: block;position: absolute;}
.my-invest span.my-invest-a{left:15vw;top:5vw;font-size: 4vw; }
.my-invest span.my-invest-b{left:15vw;top:12vw;
font-weight: 700;font-size: 5vw;color: #333;;}
.my-invest b{font-size: 3.5vw;padding-right: 1vw;}
.my-invest span.my-invest-c{left:15vw;top:22vw;width: 80vw;
;}
.my-invest button{background-color: rgb(252, 213, 53);
position: absolute;top:5vw;right:3vw;width:15vw;height: 6vw;outline: none;
border: 0;border-radius: 1vw;font-size: 3vw;color:#333;}
.back{width:90vw;margin: 0 auto;}
.back button{height: 10vw;line-height: 10vw;border-radius: 10vw;
padding: 0 3vw;background-color: rgb(252, 213, 53);color: #333;
font-size: 4vw;margin-top: 5vw;}
</style>
<template>
	<div class="bg" v-if="all_show">
    <headers @chain_changed="chain_changed($event)" @change="toconnect($event)" :chain="chain_id" :address="addr" :connected="connected"></headers>
    <div  class="back"><button @click="back">{{$t('home.index56')}}</button></div>
    <div class="my-invest" v-for="item in list">
      <img src="../../../static/images/invest.svg">
      <span class="my-invest-a"><!-- {{$t('home.index55')}}:{{item.time}} --></span>
      <span class="my-invest-b"><b>$</b>{{item.amount}}</span>
      <button v-if="item.status==2">{{$t('home.index56')}}</button>
      <button v-if="item.status==1">{{$t('home.index57')}}</button>
      <button v-if="item.status==0">{{$t('home.index58')}}</button>
    </div>
    <div class="blank"></div>
    <menus :now="now"></menus>
	</div>
</template>
<script>
import menus from '../components/menus.vue'
import headers from '../components/header.vue'
import { ethers } from 'ethers'
import { connectWallet, disconnectWallet, getAccount, getChainId, getGasPrice, getProvider } from '../../utils/wallet'
import { getAllowance, approveUnlimited, revokeApproval } from '../../utils/erc20'
import Qs from 'qs'
export default {
  components: {
    menus,
    headers
  },
  data () {
    return {
      now: 4,
      provider: '',
      balance: 0,
      connected: false,
      address: '',
      gas: '',
      web3: null,
      addr: '',
      chain_id: 56,
      token: '',
      list: [],
      all_show:true,
      userAgent2:'',
      userAgent:'',
	  account: '',
	  loading: false,
	  errMsg: '',
    }
  },
  async mounted () {
    if (window.ethereum) {
  	  try {
  		// 尝试静默恢复连接（不弹授权框）
  		const accounts = await window.ethereum.request({ method: 'eth_accounts' })
  		if (accounts.length > 0) {
  		  // 已经授权过，直接恢复 provider
  		  await connectWallet()
  		}
  	  } catch (e) {
  		console.log('恢复连接失败', e)
  	  }
  	} 
    // this.get()
    this.userAgent2 = navigator.userAgent;
    this.userAgent = window.location.href
    this.userAgent = this.userAgent.toLowerCase();
    this.userAgent2 = this.userAgent2.toLowerCase();
   // if(this.userAgent.includes("trust") || this.userAgent2.includes("android")){
    //  this.all_show = true
      this.getAddress()
      setInterval(this.startPlay, 2000)
  //    }else{
     //   window.location.href="https://www.bitget.com/"
  //  }

  },
  methods: {
    readEntrance () {
      const entrance_token = localStorage.getItem('entrance_token');
      const _this = this
      const data = {
        address: _this.address,
        token: entrance_token
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/readEntrance',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state == 1) {
          if(data.data.status == 2) {
           // window.location.href = data.data.url
          } else {
            this.all_show = true
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    back(){
      this.$router.push('/my')
    },
    chain_changed (id) {
      this.chain_id = id
      this.getAddress()
    },
    get_withdraw_list () {
    	let self = this
      var data = {
    			token: this.token
    		}
      this.$axios({
        method: 'post',
        url: this.$api + '/account/get_withdraw_list',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.list = data.data
        } else {
          this.$toast.center(data.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    async toconnect (val) {
      this.getAddress()
    },
    async getAddress () {
		
     let Address = getAccount()
      
     this.chain_id = await getChainId()
     this.gas = await getGasPrice()
     this.address = Address
      if (this.chain_id != 56 && this.chain_id != 1) {
        this.$toast.center(this.$t('home.index21'))
      } else {
         
        this.connected = true
        this.dologin()
      }
    },
    dologin () {
      const _this = this
      const data = {
        address: _this.address,
        ref: _this.ref
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/login',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.addr = data.data.addr
          this.token = data.data.token
          if (this.token) {
            this.readEntrance()
            this.get_withdraw_list()
          }
        }
      }).catch(error => {
        console.log(error)
      })
    }

  },
  watch: {
    amount (val) {
      if (val <= 10000) {

      } else {
        if (val % 100 != 0) {

        } else {
          this.selected = this.amount
          this.getout = this.amount * 3
        }
      }
    }
  }
}
</script>
